import { render, staticRenderFns } from "./text.vue?vue&type=template&id=7335a004"
import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"
import style0 from "./text.vue?vue&type=style&index=0&id=7335a004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports